<template>
  <div>
    <modal-add-transfert
      v-if="licenceSelected && licenceSelected.id!=0"
      :licence="licenceSelected"
      title="Ajouter un transfert sur cette licence"
      @addTransfert="addTransfert"
    ></modal-add-transfert>

    <form role="form">

      <div class="row">
        <div class="col-md-12">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title" v-if="licenceSelected">
                Licence {{licenceSelected.date_debut}} - {{licenceSelected.date_fin}}
                <button v-if="licenceSelected && licenceSelected.id!=0"
                        class="btn btn-primary btn-xs"
                        @click.prevent="showModalTransfert()">
                  Ajouter un transfert sur cette licence
                </button>
              </h3>
 
              <div class="pull-right">
                <select v-model="licenceSelected">
                  <!--<option value="0">Choisissez une licence</option>-->
                  <option value="-1">Ajouter une licence</option>
                  <option
                    v-for="licence in getMember.licences"
                    v-if="licence.type_rel.meta != 'transfert'"
                    :value="licence"> {{ licence.date_debut }} - {{ licence.date_fin }}
                  </option>
                </select>
              </div>
            </div>

            <div class="box-body" v-if="!licenceSelected">
              <div class="row">
                <button type="button" @click.prevent="addNewLicence()"
                        class="center-block btn btn-primary btn-flat">
                  Ajouter une licence
                </button>
              </div>
            </div>

            <div class="box-body" v-if="licenceSelected">
              <div class="overlay" v-if="isClotureValide()">
                <div class="row">
                  <div class="col-md-12" style="padding:5%;text-align: center; font-size: 16px; border:1px solid black;background-color:#FFF;width: 90%;margin: 5%;">
                    <p>Cette licence est liée à un récapitulatif au statut <strong>en attente de payement ou validé/cloturé</strong>. Toute modification de cette licence peut entraîner une modification au niveau du récapitulatif et au niveau
                      comptable.
                      <br>Souhaitez-vous modifier cette licence ?</p>
                    <button type="button"
                            class="btn btn-md btn-primary btn-flat margin align-center"
                            style="margin-top: 0;margin-bottom: 0;"
                            @click="acceptToModifyLicence=true"
                    >
                      Modifier cette licence
                    </button>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <list-select-club
                    :clubsLicenciesUniquement="true"
                    :clubPreSelected="licenceSelected.id_club!=0 ? licenceSelected.id_club : 0"
                    @clubSelected="updateClubSelected"
                    :warning="licenceSelected.id_transfert!= 0 ? true : false"
                    warningMessage="Un transfert existe pour cette licence. Le club indiqué ci-dessus est le club de la licence d'origine"
                  ></list-select-club>

                  <div class="form-group">
                    <label for="recap">Recapitulatif
                    </label>
                    <router-link
                      :to="{ name: 'Recap', params: { recap_id: licenceSelected.id_recapitulatif }}"
                      v-show="licenceSelected.id_recapitulatif!=0"
                      class="pull-right" href="">Voir le récapitulatif
                    </router-link>
                    <select class="form-control"
                            id="recap"
                            v-model="licenceSelected.id_recapitulatif"
                            :disabled="disabledSelectRecaps">
                      <option value="0">Aucun</option>
                      <option
                        v-for="recap in recapsFromClub"
                        :value="recap.id"
                      >
                        N°{{recap.id}} -
                        {{recap.club.club | uppercase}} -
                        {{formatDate(recap.created_at,'YYYY-MM-DD hh:mm:ss','DD/MM/YYYY')}}
                      </option>
                    </select>
                  </div>
                </div>

              </div>
              <div class="row">
                <div class="input-daterange" id="dataRange">
                  <div class="form-group col-md-3 "
                       :class="{'has-warning': warningMessageDate }">
                    <label>Du:</label>
                    <div class="input-group date ">
                      <div class="input-group-addon">
                        <i class="fa fa-calendar"></i>
                      </div>

                      <masked-input type="text"
                                    v-model="licenceSelected.date_debut"
                                    v-validate="'date_format:DD/MM/YYYY'"
                                    :mask="[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]"
                                    :guide="true"
                                    :keepCharPositions="true"
                                    :showMask="true"
                                    name="date_debut"
                                    class="form-control pull-right datepicker"
                                    :disabled="disabledSelectRecaps"
                                    id="datepicker2">
                      </masked-input>
                    </div>
                    <span v-show="warningMessageDate"
                          class="help-block"> Cette date est déjà couverte par une licence existante</span>
                  </div>

                  <div class="form-group col-md-3 ">
                    <label>Au:</label>
                    <div class="input-group date ">
                      <div class="input-group-addon">
                        <i class="fa fa-calendar"></i>
                      </div>
                      <input type="text" name="periodeAu"
                             disabled="disabled"
                             v-model="licenceSelected.date_fin"
                             class="form-control pull-right datepicker" id="datepicker2">
                    </div>
                    <!-- /.input group -->
                  </div>
                  <div class="col-md-6" v-if="warningGoToDoctor">
                    <b-card bg-variant="warning" text-variant="white" header="Attention" class="text-center">
                      <b-card-text>
                        <p>
                          Avec une date de nouvelle licence au {{licenceSelected.date_debut}}, ce membre a une période inactive dépassant les 365 jours.
                        </p>
                        <p><strong>La visite médicale est obligatoire!</strong></p>
                      </b-card-text>
                    </b-card>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="typeLicence">Type de licence</label>
                    <select class="form-control"
                            id="typeLicence"
                            v-model="licenceSelected.type"
                            :disabled="disabledSelectRecaps">
                      <option
                        v-for="type in getTypesLicences"
                        v-if="type.type!='Administratif' && type.type!='Transfert'"
                        :value="type.id"
                      >
                        {{type.type}}
                      </option>
                    </select>
                  </div>

                  <div class="form-group"
                       :class="{'has-error': errors.has('montant') }">
                    <label for="montant">Montant</label>
                    <div class="input-group">
                      <span class="input-group-addon">€</span>
                      <input type="text"
                             name="montant"
                             class="form-control"
                             id="montant"
                             v-validate="'required|decimal|min_value:0'"
                             v-model="licenceSelected.montant"
                             :disabled="disabledSelectRecaps"
                             placeholder="">
                    </div>
                    <span v-show="errors.has('montant')"
                          class="help-block">Montant incorrect</span>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="form-group">
                    <label>Demande de licence:</label>
                    <div class="radio">
                      <label>
                        <input type="radio"
                               v-model="licenceSelected.inscription"
                               name="demandeLicence"
                               :disabled="disabledSelectRecaps"
                               id="demandeLicence1" value="1">
                        Reçue
                      </label>
                    </div>
                    <div class="radio">
                      <label>
                        <input type="radio"
                               v-model="licenceSelected.inscription"
                               name="demandeLicence"
                               :disabled="disabledSelectRecaps"
                               id="demandeLicence2" value="0">
                        Non-reçue
                      </label>
                    </div>
                  </div>


                  <div class="form-group">
                    <label>Payement de licence:</label>
                    <div class="radio">
                      <label>
                        <input type="radio"
                               v-model="licenceSelected.payement"
                               name="payementLicence"
                               :disabled="disabledSelectRecaps"
                               id="payementLicence1" value="1">
                        Reçue
                      </label>
                    </div>
                    <div class="radio">
                      <label>
                        <input type="radio"
                               v-model="licenceSelected.payement"
                               name="payementLicence"
                               :disabled="disabledSelectRecaps"
                               id="payementLicence2" value="0">
                        Non-reçue
                      </label>
                    </div>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="form-group">
                    <label for="medical">Autorisations médicales </label>
                    <div class="checkbox">
                      <label for="apte_pratique">
                        <input id="apte_pratique"
                               name="apte_pratique"
                               type="checkbox"
                               :disabled="disabledSelectRecaps"
                               v-model="licenceSelected.apte_pratique">
                        Apte à la pratique ?
                      </label>
                    </div>
                    <div class="checkbox">
                      <label for="apte_competition">
                        <input id="apte_competition"
                               type="checkbox"
                               name="apte_competition"
                               :disabled="disabledSelectRecaps"
                               v-model="licenceSelected.apte_competition">
                        Apte à la compétition ?
                      </label>
                    </div>
                  </div>

                  <div class="form-group clearfix" v-if="licenceSelected.id!=0">
                    <label>Secrétariat</label>
                    <p>
                      <button
                        @click="printEtiquetteIndividuelle(licenceSelected.id)"
                        :disabled="disabledSelectRecaps" type="button"
                        class="btn btn-primary btn-flat margin-bottom ">
                        Imprimer l'étiquette (individuelle)
                      </button>

                      <button
                        @click="printCarteAnnuelle(licenceSelected.id_transfert!= 0 ? licenceSelected.id_transfert : licenceSelected.id)"
                        :disabled="disabledSelectRecaps" type="button"
                        class="btn btn-primary btn-flat ">
                        Imprimer la carte annuelle de licence
                      </button>
                    </p>
                  </div>

                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <button :disabled="disabledSelectRecaps || errors.count()!=0 "
                          type="button"
                          @click="sendForm()"
                          class="btn btn-primary margin pull-right">
                    {{ licenceSelected.id==0 ? "Ajouter" : "Mettre à jour" }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>

    <form role="form">
      <div class="row">
        <div class="col-md-12">
          <div class="box box-primary">
            <div class="box-header with-border">
              <b-col md="9" class="my-1">
                <h3 class="box-title">Licences</h3>
              </b-col>
              <b-col md="3" class="my-1">
                <b-form-input v-model="filter" style="height: 28px;" placeholder="Rechercher..."></b-form-input>
              </b-col>
            </div>
            <div class="box-body">
              <div class="overlay" v-if="loadingTableLicences">
                <i class="fa fa-refresh fa-spin"></i>
              </div>

              <div v-if="!loadingTableLicences">
                <b-table responsive bordered striped hover
                         :items="getMember.licences"
                         :fields="columns"
                         :per-page="perPage"
                         :filter="filter"
                         :current-page="currentPage"
                         :empty-text="'Aucun résultat'"
                         :empty-filtered-text="'Aucun résultat'"
                         show-empty
                >
                  <template slot="actions" slot-scope="row">
                    <a href="#" @click.prevent="licenceSelected=row.item"
                       class="btn btn-default padding2">
                      <i class="glyphicon glyphicon-pencil"></i>
                    </a>
                    <a href="#" @click.prevent="removeLicence(row.item.id)"
                       class="btn btn-default padding2">
                      <i class="glyphicon glyphicon-remove"></i>
                    </a>
                  </template>
                  <template slot="id" slot-scope="data">
                    {{data.value | idFormat}}
                  </template>
                  <template slot="created_at" slot-scope="data">
                    {{formatDate(data.value) }}
                  </template>
                  <template slot="type_rel" slot-scope="data">
                    {{data.value.type}}
                  </template>
                  <template slot="club" slot-scope="data">
                    <router-link :to="{ name: 'Club', params: { club_id: data.value.id }}">
                      {{data.value.club}}
                    </router-link>
                  </template>
                  <template slot="apte_pratique" slot-scope="data">
                    {{data.value ? "OUI":"NON"}}
                  </template>
                  <template slot="apte_competition" slot-scope="data">
                    {{data.value ? "OUI":"NON"}}
                  </template>
                  <template slot="recapitulatif" slot-scope="row">
                    <router-link
                      v-if="row.item.id_recapitulatif"
                      :to="{ name: 'Recap', params: { recap_id: row.item.id_recapitulatif }}">
                      Recap {{row.item.id_recapitulatif}}
                    </router-link>
                    <span v-if="!row.item.id_recapitulatif">-</span>

                  </template>
                  <template slot="montant" slot-scope="data">
                    {{data.value}}€
                  </template>
                  <template slot="id_transfert" slot-scope="row">
                    {{row.item.id_transfert ? row.item.id_transfert : "-"}}
                    <a @click.prevent="resetTransfert(row.item.id)"
                       v-if="row.item.id_transfert"
                       class="btn btn-default padding2">
                      <i class="glyphicon glyphicon-remove"></i>
                    </a>
                  </template>
                  <template slot="locked" slot-scope="data">
                    {{data.value ? "OUI":"NON"}}
                  </template>
                </b-table>
                <b-pagination size="md"
                              :total-rows="getMember.licences.length"
                              v-model="currentPage"
                              :per-page="perPage">
                </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>

  import Datepicker from 'vuejs-datepicker';

  import {mapGetters, mapActions} from 'vuex'
  import ListSelectClub from '../../Communs/listeSelectClub'
  import {ErrorBag} from 'vee-validate';
  import ModalAddTransfert from './ModalAddTransfert'

  var $ = require('jquery');
  var variables = require('../../../assets/js/variables')
  var _ = require('underscore')
  var moment = require('moment')
  var FileSaver = require('file-saver');

  export default {
    data() {
      return {
        acceptToModifyLicence: false,
        licenceSelected: null,
        recapsFromClub: null,
        warningMessageDate: false,
        disabledSelectRecaps: false,
        warningGoToDoctor: false,
        licenceAlreadyExist: null,
        disabledBtn: false,
        loadingTableLicences: false,
        dataTableLicencesMember: null,
        filter: null,
        currentPage: 1,
        perPage: 20,
        columns: [
          {
            label: 'Identifiant',
            key: 'id',
            sortable: true,
          },
          {
            label: 'Date d\'encodage',
            key: 'created_at',
            sortable: true,
          },
          {
            label: 'Type',
            key: 'type_rel',
            sortable: true,
          },
          {
            label: 'Club',
            key: 'club',
            sortable: true,
          },
          {
            label: 'Date de début',
            key: 'date_debut',
            type: 'date',
            // inputFormat: 'DD/MM/YYYY',
            // outputFormat: 'DD/MM/YYYY',
            sortable: true,
          },
          {
            label: 'Date de fin',
            key: 'date_fin',
            type: 'date',
            // inputFormat: 'DD/MM/YYYY',
            // outputFormat: 'DD/MM/YYYY',
            sortable: true,
          },
          {
            label: 'Apte pratique',
            key: 'apte_pratique',
            sortable: true,
          },
          {
            label: 'Apte competition',
            key: 'apte_competition',
            sortable: true,
          },
          {
            label: 'Récapitulatif',
            key: 'recapitulatif',
            sortable: true,
          },
          {
            label: 'Montant',
            key: 'montant',
            sortable: true,
          },
          {
            label: 'Transfert associé',
            key: 'id_transfert',
            sortable: true,
          },
          {
            label: 'Verrouillé ?',
            key: 'locked',
            sortable: true,
          },
          {
            label: 'Actions',
            key: 'actions',
          },
        ],
      }
    },
    computed: {
      ...mapGetters({
        getMember: 'getMember',
        getProfessions: 'getProfessions',
        getPays: 'getPays',
        getVilles: 'getVilles',
        getRoute: 'getRoute',
        getTypesLicences: 'getTypesLicences',
      })
    },
    methods: {
      ...mapActions({
        setProfessions: 'setProfessions',
        setLicencesOfMember: 'setLicencesOfMember',
        setPays: 'setPays',
        setVilles: 'setVilles',
        setMember: 'setMember',
      }),
      isClotureValide: function () {
        return this.licenceSelected && this.licenceSelected.recapitulatif && (this.licenceSelected.recapitulatif.statut.meta == 'done' || this.licenceSelected.recapitulatif.statut.meta == 'wait_pay') && !this.acceptToModifyLicence;
      },
      formatDate: function (value, fmtIn = 'YYYY-MM-DD hh:mm:ss', fmtOut = 'DD/MM/YYYY HH:mm') {
        if (value == null) return ''
        return moment(value, fmtIn).format(fmtOut)
      },
      showModalTransfert: function () {
        $('#modalTransfert').modal()
      },
      printCarteAnnuelle: function (id_licence = null, qrCode = true) {
        if (!id_licence)
          return;
        this.loadingSecretariatBox = true
        let these = this;
        let route = qrCode ? 'Secretariat.carteAnnuelleMembreQrcode' : 'Secretariat.carteAnnuelleMembre'
        this.$http.post
        (
          this.getRoute(route),
          JSON.stringify({"id_licence": id_licence}),
          {responseType: 'blob'}
        ).then(function (response) {
          this.loadingSecretariatBox = false
          var blob = new Blob([response.body], {type: "application/pdf;charset=utf-8"});
          FileSaver.saveAs(blob, these.getMember.fullName + "_licence.pdf");
          return response.blob();
        }, (response) => {
          these.$noty.error("Erreur dans la génération de la carte")
          this.loadingSecretariatBox = false
        });
      },
      printEtiquetteIndividuelle: function (id_licence = null) {
        if (!id_licence)
          return;
        this.loadingSecretariatBox = true
        let these = this;
        this.$http.post
        (
          this.getRoute('Secretariat.etiquetteIndividuelleMembre'),
          JSON.stringify({"id_licence": id_licence}),
          {responseType: 'blob'}
        ).then(function (response) {
          this.loadingSecretariatBox = false
          var blob = new Blob([response.body], {type: "application/pdf;charset=utf-8"});
          FileSaver.saveAs(blob, these.getMember.fullName + "_licence.pdf");
          return response.blob();
        }, (response) => {
          these.$noty.error("Erreur dans la génération de la carte")
          this.loadingSecretariatBox = false
        });
      },
      refreshListings: function () {
        this.dataTableLicencesMember = $("#licencesMember").DataTable();
        this.dataTableLicencesMember.destroy();

        this.dataTableLicencesMember = $("#licencesMember").DataTable({
          language: variables.dt_french(),
          "paging": true,
          "ordering": true,
          "info": true,
          "autoWidth": true,
        });
      },
      majLicencesTable: function () {
        this.loadingTableLicences = true;
        this.$http.get(this.getRoute('Secretariat.getInfosLicences') + this.getMember.id).then(function (response) {
          this.setLicencesOfMember(response.body)
          this.loadingTableLicences = false;
        }, (response) => {
          self.$noty.error("Erreur dans la mise à jour du tableau des licences")
          this.loadingTableLicences = false;
        })
      },
      updateClubSelected: function (value) {
        var these = this
        this.disabledSelectRecaps = true;
        this.licenceSelected.id_club = value.id
        this.$http.get(this.getRoute('getRecapsForOneClub') + value.id).then((response) => {
          these.recapsFromClub = response.body
          this.disabledSelectRecaps = false;
        });
      },
      constructForm: function () {
        return JSON.stringify({
          "id": this.licenceSelected.id,
          "date_debut": this.licenceSelected.date_debut,
          "date_fin": this.licenceSelected.date_fin,
          "id_club": this.licenceSelected.id_club,
          "type": this.licenceSelected.type,
          "montant": this.licenceSelected.montant,
          "inscription": this.licenceSelected.inscription,
          "payement": this.licenceSelected.payement,
          "apte_pratique": this.licenceSelected.apte_pratique,
          "apte_competition": this.licenceSelected.apte_competition,
          "id_recapitulatif": this.licenceSelected.id_recapitulatif,
          "id_transfert": this.licenceSelected.id_transfert,
          "id_membre": this.licenceSelected.id_membre,
        })
      },
      sendForm: function () {
        this.disabledBtn = true;
        let self = this;
        //Si c'est un update de licence
        if (this.licenceSelected.id != 0) {
          this.$http.put(this.getRoute('Secretariat.licence.update') + this.licenceSelected.id, this.constructForm()).then(function (response) {
            self.$noty.success("La licence du membre a bien été modifiée")
            this.disabledBtn = false
            this.majLicencesTable();
          }, (response) => {
            self.$noty.error("Erreur dans la modification de la licence")
            this.disabledBtn = false
          });
        } else {
          this.$http.post(this.getRoute('Secretariat.licence.store'), this.constructForm()).then(function (response) {
            self.$noty.success("La licence du membre a bien été ajoutée")
            self.licenceSelected.id = response.body.id
            this.majLicencesTable();
            this.disabledBtn = false
          }, (response) => {
            self.$noty.error("Erreur dans l'ajout de la licence")
            this.disabledBtn = false
          });
        }
      },
      getLastLicence: function () {
        return _.sortBy(this.getMember.licences, (licence) => {
          if (licence.type_rel.meta != "transfert")
            return new Date(this.$formatDate(licence.date_fin, "DD/MM/YYYY", "YYYY-MM-DD hh:mm:ss"));
        }).reverse()[0]
      },
      addNewLicence: function () {
        this.isAddingNewLicence = true
        this.licenceSelected = {
          id: 0,
          date_debut: moment().format('DD/MM/YYYY'),
          date_fin: moment().add(1, 'years').format('DD/MM/YYYY'),
          id_club: (this.getMember.licences.length > 0) ? this.getMember.licences[0].club.id : 0,
          id_membre: this.getMember.id,
          id_recapitulatif: 0,
          id_transfert: 0,
          inscription: 1,
          payement: 1,
          apte_competition: 1,
          apte_pratique: 1,
          locked: 0,
          montant: 40,
          recapitulatif: null,
          type: 2,
        }
        this.recapsFromClub = null
        this.recapsFromClub = null
        this.warningMessageDate = false
        this.disabledSelectRecaps = false
        this.licenceAlreadyExist = null
        if (this.licenceSelected && this.licenceSelected.id_club != 0)
          this.updateClubSelected({id: this.licenceSelected.id_club});
      },
      addTransfert: function (transfert) {
        this.disabledBtn = true;
        let self = this;
        this.$http.post(this.getRoute('Secretariat.addTransfert'), {
          'id_licence': this.licenceSelected.id,
          'id_club_origine': transfert.id_club_origine,
          'id_club_destination': transfert.id_club_destination,
          'date': transfert.date_inscription
        }).then(function (response) {
          self.$noty.success("Le transfert du membre a bien été effectué")
          this.majLicencesTable();
          this.disabledBtn = false
          $('#modalTransfert').modal('hide')
        }, (response) => {
          self.$noty.error("Erreur dans le transfert de la licence")
          this.disabledBtn = false
          $('#modalTransfert').modal('hide')
        });
      },
      resetTransfert: function (id_licence) {
        let self = this
        this.loadingTableLicences = true;
        this.$http.post(this.getRoute('Secretariat.resetTransfert'), {
          "id_licence": id_licence
        }).then(function (response) {
          self.$noty.success("Le transfert a bien été réinitialisé")
          this.majLicencesTable();
          this.disabledBtn = false
        }, (response) => {
          self.$noty.error("Erreur lors de la réinitialisation du transfert")
          this.disabledBtn = false
        });
      },
      removeLicence: function (id_licence) {
        if (this.licenceSelected && id_licence == this.licenceSelected.id)
          this.licenceSelected = null;
        let self = this
        this.loadingTableLicences = true;
        this.$http.post(this.getRoute('Secretariat.deleteLicence'), {
          "id_licence": id_licence,
          "id_member": self.getMember.id
        }).then(function (response) {
          self.$noty.success("La licence du membre a bien été supprimée")
          this.majLicencesTable();
          this.disabledBtn = false
        }, (response) => {
          if (response.body == 'Transfert_Exists')
            self.$noty.error("Une autre licence est dépendante de ce transfert. Réinitialisez le transfert dans la licence de base concernée.")
          else {
            self.$noty.error("Erreur dans la suppression de la licence")
            this.disabledBtn = false
          }
          this.loadingTableLicences = false
          ;
        });
      }
    },
    watch: {
      licenceSelected: function (value) {
        if (value == -1)
          return this.addNewLicence()
      },
      'licenceSelected.date_debut':
        function (val, oldVal) {

          if (!val || !oldVal)
            return;
          var these = this
          let newDate = moment(this.$formatDate(val, "DD/MM/YYYY", "YYYY-MM-DD"))
          console.log(oldVal);
          console.log(val);
          if (val != oldVal)
            this.licenceSelected.date_fin = newDate.clone().add(1, 'years').format("DD/MM/YYYY")

          this.licenceAlreadyExist = _.find(this.getMember.licences, function (licence) {
            return newDate.isBetween(
              moment(licence.date_debut, "DD/MM/YYYY"), moment(licence.date_fin, "DD/MM/YYYY"), null, '[)'
            ) && licence.id != these.licenceSelected.id && licence.type != 7
          });
          this.warningMessageDate = !_.isUndefined(this.licenceAlreadyExist)
          this.warningGoToDoctor = newDate.diff(moment(this.getLastLicence().date_fin, "DD/MM/YYYY"), 'days') > 365
        }
    },
    mounted: function () {
      var these = this

      //LicenceActive
      this.licenceSelected =
        _.find(this.getMember.licences, function (licence) {
          return moment(licence.date_fin, "DD/MM/YYYY").isBetween(moment(), moment().add(1, 'years'), null, '[]') && licence.type_rel.meta != "transfert"
        });

      this.$nextTick(function () {
      })

    },
    filters: {
      idFormat: function (value) {
        return new Intl.NumberFormat("de-DE").format(value)
      }
    },
    components: {
      ListSelectClub,
      ModalAddTransfert
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Secretariat/Membre/FormLicenceMember.vue